import React from 'react';
import { Flex } from '@chakra-ui/react';
import { ConditionA } from './Condition/ConditionA';
import { ConditionB } from './Condition/ConditionB';
import { OrCondition } from './OrCondition';

export const GiftConditions = React.memo(() => {
  return (
    <Flex
      flexDirection={{ base: 'column', md: 'row' }}
      justifyContent="space-between"
      alignItems="center"
      mt={2}
      mb={4}
    >
      <ConditionA />
      <OrCondition />
      <ConditionB />
    </Flex>
  );
});
